import { render, staticRenderFns } from "./NewPartnerMarketModal.vue?vue&type=template&id=bc12cc80&"
import script from "./NewPartnerMarketModal.vue?vue&type=script&lang=js&"
export * from "./NewPartnerMarketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports